import React from 'react';
import { View, StyleSheet } from 'react-native';
const Accordion = ({ children }) => {
    return React.createElement(View, { style: styles.container }, children);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
export default Accordion;
